const blockBody = (event: TouchEvent | WheelEvent) => {
  if (event.cancelable) {
    event.preventDefault();
  }
};

export const blockBodyWhileDragging = () => {
  document.addEventListener('touchmove', blockBody, { passive: false });
  document.addEventListener('wheel', blockBody, { passive: false });

  document.body.style.setProperty('touch-action', 'none');
  document.documentElement.style.setProperty('touch-action', 'none');
  document.body.style.setProperty('overscroll-behavior', 'none');
  document.documentElement.style.setProperty('overscroll-behavior', 'none');
};

export const unblockBodyWhileDragging = () => {
  document.removeEventListener('touchmove', blockBody);
  document.removeEventListener('wheel', blockBody);

  document.body.style.removeProperty('touch-action');
  document.documentElement.style.removeProperty('touch-action');
  document.body.style.removeProperty('overscroll-behavior');
  document.documentElement.style.removeProperty('overscroll-behavior');
};
